export default {
  'pdp:reviews:heading': 'Reviews',
  'pdp:reviews:details-text':
    'By cross-checking with our customer database, we verify whether the product was actually purchased. In that case, the review is marked as “Verified”',
  'pdp:reviews:widget:sentiment-badge': 'Our customers say',
  'pdp:reviews:widget:verified-customer': 'Verified',
  'pdp:reviews:widget:reviews': 'Reviews',
  'pdp:reviews:widget:product-reviews': 'Product reviews',
  'pdp:reviews:widget:sort': 'Sort',
  'pdp:reviews:widget:search': 'Search',
  'pdp:product-title:ratings': '{count, number} {count, plural, one {Rating} other {Ratings}}',
  'pdp:buy-panel:size': 'Variant',
  'pdp:buy-panel:amount': 'Quantity',
  'pdp:buy-panel:subscription': 'Subscription',
  'pdp:buy-panel:out-of-stock': ' - Out of stock',
  'pdp:buy-panel:order-type:one-off': 'One-time purchase',
  'pdp:buy-panel:order-type:one-off-test': 'Single purchase',
  'pdp:buy-panel:order-type:subscription': 'Regular delivery',
  'pdp:buy-panel:order-type:subscription-test': 'Save subscription',
  'pdp:buy-panel:order-type:subscription-test-2': 'Pets Deli Savings Plan',
  'pdp:buy-panel:order-type:subscription:test-message':
    '-{discount}% on your 1st order, -10% always from your 2nd order. You can change, pause or cancel your subscription at any time.',
  'pdp:buy-panel:order-type:subscription:cut-out': '{value}',
  'pdp:buy-panel:order-type:subscription:cut-out-active': '{value} subscription active',
  'pdp:buy-panel:subscription-interval:sub-title':
    'changeable, pausable or cancellable at any time',
  'pdp:buy-panel:subscription-intervals:2-weeks': '2 weeks',
  'pdp:buy-panel:subscription-intervals:4-weeks': '4 weeks',
  'pdp:buy-panel:subscription-intervals:6-weeks': '6 weeks',
  'pdp:buy-panel:subscription-intervals:8-weeks': '8 weeks',
  'pdp:buy-panel:subscription-intervals:2-weeks-test': 'Delivery every 2 weeks',
  'pdp:buy-panel:subscription-intervals:4-weeks-test': 'Delivery every 4 weeks',
  'pdp:buy-panel:subscription-intervals:6-weeks-test': 'Delivery every 6 weeks',
  'pdp:buy-panel:subscription-intervals:8-weeks-test': 'Delivery every 8 weeks',

  'pdp:buy-panel:subscription-good-choice-alert-1': 'Save {value}% with our regular delivery.',
  'pdp:buy-panel:subscription-good-choice-alert-2':
    'You can pause or cancel the delivery yourself at any time.',
  'pdp:buy-panel:add-to-cart': 'Add to cart',
  'pdp:sticky-add-to-cart:choose-variant': 'Choose variant',
  'pdp:sticky-add-to-cart:from-price': 'from',
  'pdp:buy-panel:added-to-cart': 'Added to cart',
  'pdp:buy-panel:back-in-stock': 'Notify me!',
  'pdp:buy-panel:product-out-stock': 'Out of stock',
  'pdp:buy-panel:preorder': 'Pre-order now',
  'pdp:buy-panel:price-per-kilo': 'equals:',
  'pdp:buy-panel:shipping-time': 'Delivery time: {value} working days',
  'pdp:buy-panel:pre-order-shipping-date': 'Delivery {value}',
  'pdp:buy-panel:back-in-stock:title': 'Notify me when the product is back in stock',
  'pdp:buy-panel:back-in-stock:description':
    'Enter your email here and we will notify you as soon as we have this product back in stock.',
  'pdp:buy-panel:back-in-stock:cta': 'Send',
  'pdp:buy-panel:back-in-stock:terms':
    'We will notify you when available. We do not share your email with anyone else.',
  'pdp:content:tabs:product-information-title': 'Product information',
  'pdp:included-products': 'consists of',

  'pdp:buy-panel:free-shipping-new-customer':
    '<div><strong>Free shipping</strong><p> for new customers</p></div>',
  'pdp:buy-panel:free-shipping-new-customer:without-style': 'Free shipping for new customers',
  'pdp:buy-panel:free-shipping-new-customer:test': '€0 shipping - you save €4.90',

  'pdp:buy-panel:free-shipping-existing-customer':
    '<div><strong>Free shipping</strong><p> from €60 order value</p></div>',
  'pdp:buy-panel:free-shipping-existing-customer:without-style':
    'Free shipping from €60 order value',

  'pdp:buy-panel:savings-banner-description':
    'Good choice! You <span>save {formattedSaving} per year!</span> Nice!',

  'pdp:buy-panel:coupon-price-personalization:discount-percentage':
    '{couponName} voucher applied (-{discount}%)',

  'pdp:buy-panel:coupon-price-personalization:mov-info':
    'Voucher applies to orders from {mov}€ order value',

  'pdp:buy-panel:recommended-alternative:title': 'Try this alternative:',

  'common:one-time-purchase:title': 'One-time delivery',

  'pdp:subscription-confirmation-information:sub-number': 'Subscription ({aboId})',
  'pdp:subscription-confirmation-information:success': 'Successfully added',
  'pdp:subscription-confirmation-information:interval': 'Delivery: ',
  'pdp:subscription-confirmation-information:next-delivery': 'Next delivery: ',
  'pdp:subscription-confirmation-information:cta:manage-subscription': 'Manage subscription',
  'pdp:subscription-confirmation-information:cta:continue-shopping': 'Continue shopping',
  'pdp:AddToExistingSubscriptionButton:added-successfully': 'Successfully added',
  'pdp:AddToExistingSubscriptionButton:do-you-have-sub':
    'Already have a subscription? Then simply log in, add it to your subscription and save.',
  'pdp:AddToExistingSubscriptionButton:add-to-sub:one-off': 'Deliver with subscription',
  'pdp:AddToExistingSubscriptionButton:add-to-sub:subscription': 'Add to subscription',
  'pdp:AddToExistingSubscriptionButton:please-choose-your-abo': 'Please choose your subscription',
  'pdp:AddToExistingSubscriptionButton:shipping': 'Delivery',
  'pdp:subscription-confirmation-information:limited-items':
    'It\'s not yours yet! To ensure the product lands safely in your delivery, select the <b>"Deliver immediately"</b> option in <b>"Manage subscription"</b>',

  'pdp:buy-panel:eta-communication:days': 'The product will be available again on {eta}.',
  'pdp:buy-panel:eta-communication:weeks':
    'The product will be available again in {eta} {eta, plural, one {week} other {weeks}}.',
  'pdp:buy-panel:eta-communication:months':
    'The product will be available again in {eta} {eta, plural, one {month} other {months}}.',
  'pdp:buy-panel:eta-communication:unknown': 'The product is unavailable indefinitely.',

  'pdp:gallery:product-video': 'Product video',
};
